import * as React from 'react';

import { Dot } from '@mint-lib/icons';
import { cn } from '@mint-lib/tw-utils';
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('grid gap-3', className)}
      {...props}
    />
  );
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
  readonly?: boolean;
}) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'focus-visible::outline-2 flex h-3.5 w-3.5 cursor-pointer items-center justify-center rounded-full border border-icon-primary focus:outline-offset-1 focus:outline-action-focusBorder data-[state=checked]:border data-[state=checked]:border-tertiary-main',
        props.disabled &&
          'cursor-auto data-[state=checked]:border-action-disabled01 data-[state=unchecked]:border-action-disabled01',
        props.readonly &&
          'pointer-events-none cursor-auto focus:outline-none data-[state=checked]:border-action-disabled02 data-[state=unchecked]:border-action-disabled02',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <Dot
          className={cn(
            'fill-tertiary-main p-0.5',
            props.disabled && 'fill-action-disabled01',
            props.readonly && 'fill-action-disabled02',
          )}
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
